export const DEFAULT_MEMBER = {
	member_type: '',
	billing: 'monthly',
	renewal: '',
	amount: '25',
	allow_linked: false,
	linked_limit: 3,
	visible: true,
	free_type: false,
	directory_list: false
};
